export class ModelSerialNumber {
  constructor(
    technicalId,
    format,
    description,
    errorMessage,
    guaranteeExclusion,
    type
  ) {
    this.technicalId = technicalId
    this.format = format
    this.description = description
    this.errorMessage = errorMessage
    this.guaranteeExclusion = guaranteeExclusion
    this.type = type
  }
}
